import MessageIcon from '@material-ui/icons/ViewList';

import MessageList from './CardReuseBatchList';
import MessageCreate from './CardReuseBatchCreate';
import MessageEdit from './CardReuseBatchEdit';

export default {
    list: MessageList,
    create: MessageCreate,
    edit: MessageEdit,
    icon: MessageIcon,
};
